import { BaseModel } from "sjs-base-model";

export default class RichiestaOtpModel extends BaseModel {
    public readonly ok: boolean | null = null;
    public readonly info: string = "";

    constructor(data: Partial<RichiestaOtpModel>) {
        super();

        this.update(data);
    }
}
